interface TProgress {
  show: boolean;
  progress: number;
}

export const useShowProgress = (pathname: string): TProgress => {
  switch (pathname) {
    case "/ka/review-details":
    case "/en/review-details":
    case "/uk/review-details":
      return {
        progress: 1,
        show: true,
      };
    case "/ka/citizenship":
    case "/en/citizenship":
    case "/uk/citizenship":
      return {
        progress: 2,
        show: true,
      };
    case "/ka/address":
    case "/en/address":
    case "/uk/address":
      return {
        progress: 3,
        show: true,
      };
    case "/ka/employment":
    case "/en/employment":
    case "/uk/employment":
    case "/ka/employment/details":
    case "/en/employment/details":
    case "/uk/employment/details":
    case "/ka/employment/self":
    case "/en/employment/self":
    case "/uk/employment/self":
      return {
        progress: 4,
        show: true,
      };
    case "/ka/source-of-income":
    case "/en/source-of-income":
    case "/uk/source-of-income":
    case "/ka/expected-monthly-incomes":
    case "/en/expected-monthly-incomes":
    case "/uk/expected-monthly-incomes":
      return {
        progress: 5,
        show: true,
      };

    case "/ka/annual-transactions":
    case "/en/annual-transactions":
    case "/uk/annual-transactions":
      return {
        progress: 6,
        show: true,
      };
    case "/ka/purpose-of-relationship":
    case "/en/purpose-of-relationship":
    case "/uk/purpose-of-relationship":
      return {
        progress: 7,
        show: true,
      };
    case "/ka/pep":
    case "/en/pep":
    case "/uk/pep":
    case "/ka/pep/details":
    case "/en/pep/details":
    case "/uk/pep/details":
      return {
        progress: 8,
        show: true,
      };
    default:
      return {
        show: false,
        progress: 0,
      };
  }
};
